import { render, staticRenderFns } from "./order_type.vue?vue&type=template&id=53e2aa14&scoped=true"
import script from "./order_type.vue?vue&type=script&lang=js"
export * from "./order_type.vue?vue&type=script&lang=js"
import style0 from "./order_type.vue?vue&type=style&index=0&id=53e2aa14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e2aa14",
  null
  
)

export default component.exports